import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Managers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
        {field: item => item.school ? item.school.name : '-', label: window.gettext('School')},
        {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
        {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
    ]

    filtersSelector = createSelector.bind(this)(
        [
            () => this.props.store.getIn(['regionsTreeFilter']),
            () => this.props.store.getIn(['citiesTreeFilter']),
            () => this.props.store.getIn(['schoolsTreeFilter']),
        ],
        () => [
            {
                field: 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            'region': this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'school',
                label: window.gettext('School'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('schoolsTreeFilter')}
                        readonly
                        header
                        resource='school'
                        itemLabel={school => `${school.city.name} - ${school.name}`}
                        filter={{
                            'city': this.props.store.getIn(['citiesTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('School')}
                    />
                </div>,
                selected: this.props.store.getIn(['schoolsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'school',
                    this.props.store.getIn(['schoolsTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'firstname', label: window.gettext('Firstname')},
        {name: 'lastname', label: window.gettext('Lastname')},
        {name: 'school', label: window.gettext('School')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
        ],
        () => this.props.readonly
            ? this.props.buttonActions
            : _.concat(this.props.buttonActions, [
                {
                    label: window.gettext('New Manager'),
                    action: () => this.context.store.dispatch(push(
                        this.context.store.getState().getIn(
                            ['routing', 'locationBeforeTransitions', 'pathname'],
                        ) + 'add/',
                    )),
                },
            ]),
    )

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='manager'
            title={window.gettext('Managers')}
            listFields={this.listFields}
            selectable={this.props.selectable}
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.buttonActionsSelector(this.props.store)}
        />;
    }
}
